module.exports = __webpack_public_path__ + "media/images/featured-2-desktop-38c5d1d85e432e669d5eb75350c1e3c2.webp";